import { Injectable,PLATFORM_ID,Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { favourites } from 'src/interface/article';

@Injectable({
    providedIn: 'root'
})
export class FavouriteService {
    @Inject(PLATFORM_ID) private platformId;
    private current_favourite: favourites[] = [];

    
    setFavourite(favourite: favourites) {
        if (isPlatformBrowser(this.platformId)) {
        const favouriteData = sessionStorage.getItem('favourites');
        this.current_favourite = favouriteData
            ? JSON.parse(favouriteData)
            : this.current_favourite;
        // Check if the current_favourite array contains the incoming data
        const index = this.current_favourite.findIndex(item =>
            item.jnl_id === favourite.jnl_id &&
            item.volume === favourite.volume &&
            item.issue === favourite.issue &&
            item.article_id === favourite.article_id
        );

        // If the data exists in the array, remove it; otherwise, add it
        if (index !== -1) {
            this.current_favourite.splice(index, 1); // Remove the item
        } else {
            this.current_favourite.push(favourite); // Add the item
        }
        if (isPlatformBrowser(this.platformId)) {

        localStorage.setItem('favourites', JSON.stringify(this.current_favourite));
        }
    }
    
    }
    getFavourite(favourite): boolean {
        if (isPlatformBrowser(this.platformId)) {
          const favourite_data = localStorage.getItem('favourites');
    
          this.current_favourite = favourite_data
            ? JSON.parse(favourite_data)
            : this.current_favourite;
    
          // Check if the current_favourite array contains the incoming data
          const index = this.current_favourite.findIndex(item =>
            item.jnl_id === favourite.jnl_id &&
            item.volume === favourite.volume &&
            item.issue === favourite.issue &&
            item.article_id === favourite.article_id
          );
    
          // If the data exists in the array, return true; otherwise, return false
          return index !== -1;
        } else {
          // Return a default value for non-browser environments
          return false;
        }
    // getFavourite(favourite) {
    //     if (isPlatformBrowser(this.platformId)) {
    //     const favourite_data = localStorage.getItem('favourites');
        
    //     this.current_favourite = favourite_data
    //         ? JSON.parse(favourite_data)
    //         : this.current_favourite;
    //     // Check if the current_favourite array contains the incoming data
    //     const index = this.current_favourite.findIndex(item =>
    //         item.jnl_id === favourite.jnl_id &&
    //         item.volume === favourite.volume &&
    //         item.issue === favourite.issue &&
    //         item.article_id === favourite.article_id
    //     );
        

    //     // If the data exists in the array, remove it; otherwise, add it
    //     if (index !== -1) {
    //         return true;
    //     } 
    //         return false;
        
    // }
    }
    
}
